import { WidgetActionMethod } from '../../WidgetVariant';

enum FloatingInputCardActionMethod {
  Hide = 'hide',
  Show = 'show',
  InitiateSimplrChat = 'initiateSimplrChat',
}

export type ActionMethod = FloatingInputCardActionMethod | WidgetActionMethod;

export const ActionMethod = {
  ...FloatingInputCardActionMethod,
  ...WidgetActionMethod,
};
